
const strings = {
  "appname": "Adventskalender 2023",
  "adventskalender": "Adventskalender",
  "jahr": "2023",
  "menu": "Menü",
  "close": "Schließen",
  "weiter": "Weiter",
  "back": "Zurück",
  "login": "Anmelden",
  "logout": "Abmelden",
  "email": "Max.Mustermann@gmail.com",
  "emailFail": "Bitte geben Sie eine richtige Emailadresse ein!",
  "angemeldetals": "Sie sind angemeldet mit:",
  "nichtangemeldet": "Sie sind nicht angemeldet!",

  "glueckwunsch": "Herzlichen Glückwunsch!",
  "gewinnText1": "\n\nSie bekommen heute\n",
  "gewinnText2": "\nvon uns geschenkt!",
  "gutscheincode": "Ihr Gutscheincode lautet:",
  "gutscheincodekundenkonto": "Falls Sie ein Kundenkonto bei\nuns haben, werden Ihre Gewinne\ndort ebenfalls aufgeführt.",
  "gewinnperemail": "Ihr Gutscheincode\nwird Ihnen automatisch\nper E-mail zugeschickt!",
  "danke": "Wir hoffen, wir konnten Ihnen\neine kleine Freude bereiten!",
  "danke2": "Bis morgen...",
  "folgen": "Übrigens, wir führen öfter im Jahr\nkostenlose Gewinnspiele durch.\nBleiben Sie auf dem Laufenden und\nfolgen Sie uns...",

  "doorFail1": "Dieses Türchen geht erst\nam",
  "doorFail2": "auf...",
  "dezember": ". Dezember",
  "doorFail3": "Das heutige Türchen wurde bereits von Ihnen geöffnet!\n\nDies war hinter Ihrem Türchen:",
  "doorFail4": "Bis morgen...",
  "doorFail5": "Der",
  "doorFail6": "ist schon vorbei.",

  "infos": "Informationen",
  "empfehlen": "Einem Freund empfehlen",
  "empfehlenText": "Schau dir mal diesen schönen Adventskalender an. Hier gibt es jeden Tag tolle Rabatte und Gratiskarten. \n\nhttps://www.urlaubsgruss.com/adventskalender/",
  "teilenfehler": "WhatsApp nicht gefunden!\n\nScheinbar ist das Programm auf diesem Gerät nicht verfügbar!",
  "teilnahmebedingungen": "Teilnahmebedingungen",
  "impressum": "Impressum",
  "datenschutz": "Datenschutz",
  "agb": "AGB",
  "support": "Hilfe per E-mail",
  "ugweb": "Zur Urlaubsgruss Startseite",
  "ugapp": "Zur App",
  "kartendesigns": "Weihnachtskarten verschicken",

  "emaileingeben": "Bitte geben Sie Ihre Email-Adresse ein:",

  "weiterzuadvent": "Adventskalender starten",
  "teilnahmebedingungencheck": "Ich habe die Teilnahmebedingungen gelesen, verstanden und stimme diesen mit meiner Teilnahme zu.",
  "teilnahmebedingungencheck1": "Ich habe die",
  "teilnahmebedingungencheck2": "gelesen, verstanden und stimme diesen mit meiner Teilnahme zu.",
  "newslettercheck": "Gerne möchte ich in Zukunft über Aktionen und Gewinnspiele per Email informiert werden.",

  "handydrehen": "Bitte drehen Sie Ihr Smartphone.",
  "fehlerbeiabfrage": "Es gab einen Fehler bei der Gewinnabfrage!\n\nBitte versuchen Sie es später erneut.",
  "nureinmalprotag": "Sie haben heute bereits ein Türchen geöffnet.\nPro Haushalt kann unser Adventskalender nur 1 Mal am Tag geöffnet werden.\n\nBitte kommen Sie morgen wieder! 😘",
  "erstabdezember": "Herzlich Willkommen!\n\nUnser Adventskalender beginnt am\n01. Dezember 2023 um 0:00 Uhr.\n\nBitte kommen Sie später wieder!\n\nWir freuen uns auf Sie!",

  "datenschutzinfo": "Was machen wir mit\nIhrer Emailadresse?",

}

export default {
  strings
};

